<template>
	<el-dialog title="维修记录" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="page_warp">
			<!-- <div style="height: 50px;">
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div
							style="display: flex;width: 350px; height: 35px;align-items: center;justify-content: flex-start;">
							维修时间：
							<el-date-picker style="width: 250px; height: 35px" v-model="sUnlonddayArr"
								type="datetimerange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
								clearable format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss">
							</el-date-picker>
						</div>
						<div class="search_btn" @click="getData()">查询</div>
						<div class="search_btn" @click="exportClick()" v-if="permissionItem.export">导出</div>
					</div>
				</div>
			</div> -->
			<!-- <div class="flex">
				<div class="rpt_tit">
					<p class="platTitle">维修记录
					</p>
				</div>
			</div> -->
			<div class="bottom_content">
				<div class="table_container" v-bind:id="tableId">
					<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="500"
						v-bind:header-cell-style="{
						  textAlign: 'center',
						  color: '#333333',
						  background: '#F5F5F5',
						}" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
						<el-table-column type="index" label="序号" width="80"></el-table-column>
						<el-table-column prop="vehNo" label="车牌号码" width="120"></el-table-column>
						<el-table-column prop="verrStatus" label="维修状态" width="120">
							<template #default="scope">
								<span v-if="scope.row.verrStatus == '1'" style="color: #00aa00;">维修完成</span>
								<span v-else style="color: #0000ff;">维修中</span>
							</template>
						</el-table-column>
						<el-table-column prop="verrTitle" label="维修标题" width="120"></el-table-column>
						<el-table-column prop="verrTime" label="维修日期" width="170"></el-table-column>
						<el-table-column prop="verrMoney" label="维修费用(元)" width="120"></el-table-column>
						<el-table-column prop="verrDescribe" label="维修描述" width="200"></el-table-column>
						<el-table-column prop="verrHandler" label="维修经办人" width="120"></el-table-column>
						<el-table-column prop="verrPayStatus" label="支付状态" width="120">
							<template #default="scope">
								<span v-if="scope.row.verrPayStatus == '0'">未支付</span>
								<span v-else-if="scope.row.verrPayStatus == '1'">已支付</span>
								<span v-else>--</span>
							</template>
						</el-table-column>
						<el-table-column prop="verrPayDate" label="支付日期" width="170"></el-table-column>
						<el-table-column prop="verrPayAccount" label="支付账户" width="150"></el-table-column>
						<el-table-column prop="verrCretime" label="创建时间" width="170"></el-table-column>
						<el-table-column label="操作" fixed="right" width="150">
							<template #default="scope">
								<span class="default_color pointer m-right10"
									v-on:click="editRecord(scope.row.verrId)">编辑</span>
								<span class="default_color pointer m-right10"
									v-on:click="detailRecord(scope.row.verrId)">详情</span>
								<span class="col-FF1A1A pointer m-right10" v-on:click="del(scope.row.verrId)">删除</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="flex flex-y-center flex-x-center m-top30">
					<el-config-provider :locale="locale">
						<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
							:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
							:total="totalCount" @size-change="getData" @current-change="getData" />
					</el-config-provider>
				</div>
			</div>

			<DetailRecord ref="detailRecordRef" v-if="isDetailRecord" @getData="getData" />
			<EditRecord ref="editRecordRef" v-if="isEditRecord" @getData="getData" />
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		computed,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import DetailRecord from "./detailRecord";
	import EditRecord from "./editRecord";
	export default defineComponent({
		components: {
			DetailRecord,
			EditRecord
		},
		name: "Detail",
		// emits: ["getData"],

		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			// const getData = () => {
			// 	context.emit("getData");
			// };


			const data = reactive({
				tableId: "roleManagementTable",
				isDetail: false,
				isDetailRecord: false,
				isEditRecord: false,
				searchWord: "",
				index: 0,
				page: 1,
				pageSize: 10,
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				olseDefedit: false,
				olseDefeditisReadOnly: true,

				verrVehId: '',

				permissionItem: {
					list: false,
					del: false,
					set: false,
					export: false,
				},

			});

			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "lineManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "lineManage:del") {
						data.permissionItem.del = true;
					}
					if (el == "lineManage:set") {
						data.permissionItem.set = true;
					}
					if (el == "lineManage:export") {
						data.permissionItem.export = true;
					}
				});

				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;

				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});

			//重置数据
			const init = async (id) => {
				data.isDetail = true;
				data.verrVehId = id;
				console.log(id);

				getData();
			};

			//获取列表数据
			const getData = async () => {
				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					verrVehId: data.verrVehId, //车辆ID
					verrType: 0, //类型：0维修，1出险
					vehNo: '', //车牌号
					vehOrg: '', //车辆机构
				};
				const r = await proxy.$http.get(apiObj.vehRepairReclist, params);
				if (r.code === 0 || r.respCode === '0000') {
					data.tableData = r.rows;
					data.totalCount = r.total;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};


			const navClick = (index) => {
				data.index = index;
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};

			const timeDeltaCount = function(time) {
				if (time) {
					var s = time % 60;
					var m = Math.floor(time / 60) % 60;
					var h = Math.floor(Math.floor(time / 60) / 60);

					if (h !== 0) {
						return h + "小时" + m + "分";
					}
					if (m !== 0) {
						return m + "分";
					}
					return s + "秒";
				} else {
					return ''
				}
			};

			// 菜单详情
			const detailRecord = (id) => {

				data.isDetailRecord = true;
				nextTick(() => {
					proxy.$refs.detailRecordRef.init(id);
				});
			};

			// 菜单编辑
			const editRecord = (id) => {

				data.isEditRecord = true;
				nextTick(() => {
					proxy.$refs.editRecordRef.init(id);
				});
			};

			const del = (id) => {
				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							verrId: id,
						};
						const r = await proxy.$http.postFormData(apiObj.vehRepairRecremove,
							params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};


			return {
				...toRefs(data),
				init,
				closeModal,
				dialogClosedHandle,
				getData,
				navClick,
				timeDeltaCount,
				detailRecord,
				editRecord,
				del,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 600px;
	}

	.top_content {
		width: 100%;
		height: 70px;
		padding: 0 25px;
		margin-bottom: 10px;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}

	.bottom_content {
		width: 100%;
		height: calc(100% - 100px);
		background: #ffffff;
	}

	.bottom_content .table_container {
		width: calc(100% - 50px);
		height: calc(100% - 10px);
		margin: 0 auto;
		padding-top: 0px;
	}

	.nav_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 78px;
		padding: 0 20px;
		margin-left: 50px;
		cursor: pointer;
	}

	.nav_item span {
		font-size: 18px;
		color: #666666;
		line-height: 78px;
	}

	.nav_item_ac span {
		color: #293787 !important;
	}

	.nav_item_line {
		position: absolute;
		width: 90%;
		left: 5%;
		height: 3px;
		background: #293787;
		bottom: 5px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 20px;
		font-size: 15px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
		padding-bottom: 10px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 0px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 100px;
		justify-content: flex-start;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.rpt_tit {
		width: 100%;
		height: 30px;
		text-align: left;
		font-weight: bold;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 0px;
		padding-bottom: 10px;
	}

	.editimg {
		width: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
		color: blue;
	}

	.editimg img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}

	.auditwait {
		width: 35px;
		height: 16px;
		background: #0000ff;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 18px;
		color: #fff;
		padding: 0 5px;
		margin-left: 20px;
	}
</style>